import { DialogPopupTypes } from '@touche-lts/panel-ui/dist'
import { makeAutoObservable } from 'mobx'
// import { RootStore } from 'mobx-stores'
import { DepartmentCategory, DepartmentsDTO } from 'models/departments'

export class DepartmentsStore {
  private rootStore: any

  constructor(rootStore: any) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  //OBSERVABLES
  private store: Partial<DepartmentsDTO> = null

  private categoryStore: Partial<DepartmentCategory> = null

  // ACTIONS
  public setStore = (store: Partial<DepartmentsDTO>): void => {
    this.store = store
  }

  public setStoreCategory = (categoryStore: Partial<DepartmentCategory>): void => {
    this.categoryStore = categoryStore
  }

  public setStoreProps = (props: Partial<DepartmentsDTO>): void => {
    this.setStore({ ...this.store, ...props })
  }

  public setStorePropsCategory = (props: Partial<DepartmentCategory>): void => {
    this.setStoreCategory({ ...this.categoryStore, ...props })
  }

  public setSubcategoryName = (name: any, subcategoryIndex: number): void => {
    this.categoryStore.subcategories[subcategoryIndex].name = name;
  }

  public setSubtypeName = (name: any, typeIndex: number): void => {
    this.categoryStore.types[typeIndex].name = name;
  }

  public setParentSubcategory = (parentSubcategorySelected: string, subcategoryIndex: number): void => {
    const selectedSubcategoty = this.parentSubcategory.find(category => category.label === parentSubcategorySelected);
    this.categoryStore.types[subcategoryIndex].parentSubcategory = selectedSubcategoty.id;
    this.categoryStore.types[subcategoryIndex].parentSubcategoryName = parentSubcategorySelected;

  }

  public setTypesForCategory = (typeValues: string[], indexTypeGroup: number): void => {
    const subtypesGroup = typeValues.map((typeValue: string) => {
      return {
        name: typeValue
      }
    });
    this.categoryStore.types[indexTypeGroup].subtypes = subtypesGroup;
  }

  public addSubcategory = (): void => {
    this.categoryStore.subcategories.push({
      name: ''
    });
  }

  public openCategory = (departmentId: string | number, categoryIndex: number): void => {
    const { routingStore: { push },
      imagesStore: { clearStore }
    } = this.rootStore;
    clearStore();
    localStorage.setItem('subCategoryEdit', JSON.stringify(this.store.categories[categoryIndex]));
    push(`/departments/${departmentId}/${this.store.categories[categoryIndex].id}`);
  }

  public addType = (): void => {
    this.categoryStore.types.push({
      name: '',
      parentSubcategory: {
        id: null,
        name: ''
      },
      subtypes: []
    });
  }

  // COMPUTED
  public get departmentStore(): Partial<DepartmentsDTO> {
    return this.store
  }

  public get departmentCategory(): Partial<DepartmentCategory> {
    return this.categoryStore
  }

  public get subcategoryExist(): boolean {
    return !!this.categoryStore?.subcategories?.filter(category => !!category.name)?.length
  }

  public get parentSubcategory(): any {
    return this.categoryStore?.subcategories?.map(category => ({
      label: category.name,
      value: category.name,
      id: category.id
    }))
  }

  // METHODS
  public addUpdateDepartment = async (departmentId?): Promise<DepartmentsDTO> => {
    const {
      generalStore: { showSuccess, showError },
      routingStore: { push }
    } = this.rootStore
    let store = null;

    if (departmentId) {
      await this.updateImages();
      store = await this.rootStore.generalStore.api.departmentsApi.updateDepartment(this.store);
      if (!store) return;
      this.setStore(store);
      // TODO-A To check if this part may be needed
      showSuccess(`Department ${store.name} updated successfully.`)
    } else {
      await this.uploadImages();
      store = await this.rootStore.generalStore.api.departmentsApi.addDepartment(this.store);
      if (!store) return;
      showSuccess(`Department ${store.name} created successfully.`)
    }
    push('/departments');
  }

  public updateImages = async (isDepartmentCategory?: boolean) => {
    let storeCrop: Partial<DepartmentsDTO> | Partial<DepartmentCategory>;
    if (isDepartmentCategory) {
      storeCrop = this.departmentCategory;
    } else {
      storeCrop = this.store;
    }
    const {
      generalStore: {
        api: { uploadFileSigned }
      },
      imagesStore: {
        squareImage,
        backgroundImage,
        getPositionSquare,
        getPositionBackground,
        getScaleSquare,
        getScaleBackground
      }
    } = this.rootStore
    if (!squareImage) {
      storeCrop.squareCrop = null
    }
    else if (squareImage[0].file === squareImage[0].link) {
      storeCrop.squareCrop = {
        url: squareImage[0].link,
        squareX: getPositionSquare.x,
        squareY: getPositionSquare.y,
        squareWidth: getScaleSquare
      }
    }
    else {
      const squreResult = await uploadFileSigned(squareImage[0].file as File)
      storeCrop.squareCrop = {
        url: squreResult.location,
        squareX: getPositionSquare.x,
        squareY: getPositionSquare.y,
        squareWidth: getScaleSquare
      }
    }
    if (!backgroundImage) {
      storeCrop.backgroundCrop = null
    }
    else if (backgroundImage[0].file === backgroundImage[0].link) {
      storeCrop.backgroundCrop = {
        url: backgroundImage[0].link,
        squareX: getPositionBackground.x,
        squareY: getPositionBackground.y,
        squareWidth: getScaleBackground
      }
    }
    else {
      const backgroundResult = await uploadFileSigned(backgroundImage[0].file as File)
      storeCrop.backgroundCrop = {
        url: backgroundResult.location,
        squareX: getPositionBackground.x,
        squareY: getPositionBackground.y,
        squareWidth: getScaleBackground
      }
    }
  }

  public uploadImages = async () => {
    const {
      generalStore: {
        api: { uploadFileSigned }
      },
      imagesStore: {
        squareImage,
        backgroundImage,
        getPositionSquare,
        getPositionBackground,
        getScaleSquare,
        getScaleBackground
      }
    } = this.rootStore
    if (squareImage !== null) {
      const squreResult = await uploadFileSigned(squareImage[0].file as File)

      this.store.squareCrop = {
        url: squreResult.location,
        squareX: getPositionSquare.x,
        squareY: getPositionSquare.y,
        squareWidth: getScaleSquare
      }
    }

    if (backgroundImage !== null) {
      const backgroundResult = await uploadFileSigned(backgroundImage[0]?.file as File)

      this.store.backgroundCrop = {
        url: backgroundResult.location,
        squareX: getPositionBackground.x,
        squareY: getPositionBackground.y,
        squareWidth: getScaleBackground
      }
    }
  }

  public getDepartmentById = async (departmentId: string | number): Promise<DepartmentsDTO> => {
    const store = await this.rootStore.generalStore.api.departmentsApi.getDepartmentById(departmentId);
    if (!store) return;
    this.setStore(store);
  }

  public addCategoryDepartment = async (departmentId: string | number): Promise<DepartmentCategory> => {
    const {
      generalStore: { showSuccess, showError },
    } = this.rootStore



    if (!this.categoryStore.name) {
      showError('Please enter a name.')
      return;
    }
    await this.updateImages(true);
    const store = await this.rootStore.generalStore.api.departmentsApi.addCategotyDepartment(this.categoryStore, departmentId), // TODO-IMPORTANT To doublechek
      { push } = this.rootStore.routingStore;

    if (!store) return;
    push('/departments/' + departmentId);

    if (!this.categoryStore.id) {
      showSuccess(`Category ${this.categoryStore.name} successfully added.`)
    } else {
      showSuccess(`Category ${this.categoryStore.name} updated successfully.`)
    }
  }

  public onSuspendDepartmentClick = async (departmentStore): Promise<void> => {
    const {
      generalStore: { openDialogPopup, closeDialogPopup, showSuccess },
      routingStore: {
        push
      },
    } = this.rootStore

    openDialogPopup({
      type: DialogPopupTypes.WARNING,
      message: `Are you sure you want to suspend ${departmentStore?.name} department ?`,
      closeButtonLabel: 'No',
      buttons: [
        {
          children: 'Yes',
          preset: 'primary',
          onClick: async () => {
            const department = await this.rootStore.generalStore.api.departmentsApi.deactivateDepartmentId(departmentStore.id)
            if (!department) {
              closeDialogPopup()
              return;
            }
            closeDialogPopup()
            showSuccess(`${departmentStore?.name} department has been suspended successfully`);
            this.rootStore.departmentsTableStore.triggerSearch();
            push('/departments');
          }
        }
      ]
    })
  }


  public resetStore = (): void => {
    this.store = null
  }

  public resetCategoryStore = (): void => {
    this.setStoreCategory({
      name: '',
      subcategories: [],
      types: [],
      backgroundCrop: null,
      squareCrop: null
    })
  }

}
